<template>
  <div id="app">
    <focuson></focuson>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  import focuson from './focuson/focuson'
  export default {
    name: 'App',
    components: {
      focuson
    }
  }
</script>
<style>
  /*引入common.css文件*/
  @import '../src/assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/App.vue